// Single source for the public "talk to us" address and the mailto
// builder that every plan-request / contact button funnels through.
// The body always carries org + email context so a triage on our side
// doesn't need to dig through Firestore.

export const CONTACT_EMAIL = "hello@formular.so";

export type ContactCtx = {
  orgId?: string;
  orgName?: string;
  email?: string;
};

export function buildContactMailto(
  subject: string,
  ctx: ContactCtx = {},
  bodyLead?: string,
): string {
  const fullSubject = `[Formular] ${subject}${
    ctx.orgName ? ` — ${ctx.orgName}` : ""
  }`;
  const body = [
    "Hola,",
    "",
    bodyLead ?? subject,
    "",
    ctx.orgId || ctx.orgName ? `Org: ${ctx.orgName ?? ctx.orgId}` : null,
    ctx.email ? `Email: ${ctx.email}` : null,
    "",
    "Gracias.",
  ]
    .filter((line): line is string => line !== null)
    .join("\n");
  return `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
    fullSubject,
  )}&body=${encodeURIComponent(body)}`;
}
